import { motion } from 'framer-motion';
import React from 'react';

const More = () => {
  const skillAnimation = {
    hidden: { opacity: 0, x: -50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1 + 1.6, // Menambah delay base 1.6s
        duration: 0.5,
        type: "spring",
        stiffness: 100
      }
    })
  };

  const skills = [
    { name: 'Git', level: 'Intermediate' },
    { name: 'Docker', level: 'Basic' },
    { name: 'Google Cloud', level: 'Basic' },
    { name: 'Digital Product Designer', level: 'Intermediate' }
  ];

  return (
    <motion.div 
      className='skills__content'
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400 }}
    >
      <motion.h3 
        className="skills__title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        More Skills
      </motion.h3>

      <br />

      <div className="skills__box">
        <div className="skills__group">
          {skills.map((skill, index) => (
            <motion.div 
              className="skills__data" 
              key={index}
              variants={skillAnimation}
              initial="hidden"
              whileInView="visible"
              custom={index}
            >
              <i className="uil uil-check-circle" />
              <div>
                <motion.h3 
                  className="skills__name"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 * index }}
                >
                  {skill.name}
                </motion.h3>
                <motion.span 
                  className="skills__level"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 * index }}
                >
                  {skill.level}
                </motion.span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default More;
